import {Pipe, PipeTransform} from '@angular/core';
import OrderItem from '../../../_entities/orders/order-item.entity';
import {OrderItemModel} from '../../../_models/orders/order-items/order-item.model';


@Pipe({
    name: 'asOrderItemArray',
    pure: true
})
export class AsOrderItemArrayPipe implements PipeTransform {
    transform<T extends 'model' | 'entity'>(orderItems: OrderItem[], model: T): T extends 'entity' ? OrderItem[] : OrderItemModel[]{
        return orderItems;
    }
}
